import "../../assets/stylesheets/application.css";
import "@fortawesome/fontawesome-free/js/all";
import "flatpickr/dist/themes/material_green.css";
import "flatpickr/dist/plugins/monthSelect/style.css";
